import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lifetime-fee-cost-calculator',
  component: () => import('../../routes/LifetimeFeeCostCalculator.svelte'),
  card: {
    id: 'lifetime-fee-cost-calculator',
    title: 'Lifetime Fee Cost Calculator',
    description: 'See how investment fees compound over your lifetime and cost you thousands in lost growth.',
    icon: 'receipt_long',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/lifetime-fee-cost-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Lifetime Fee Cost Calculator – See How Investment Fees Drain Your Portfolio',
    description: 'Free lifetime fee cost calculator. See how annual investment fees compound over 10, 20, or 30 years and cost you thousands in lost growth. Compare portfolios with and without fees.',
  },
};

export default meta;